import { qlubLocalStorage } from '../storage/localStorage';

export interface IMenuAuth {
    access: string;
    refresh: string;
}

const menuAuth: IMenuAuth = {
    access: '',
    refresh: '',
};

export const setMenuAuth = ({ access, refresh }: IMenuAuth) => {
    menuAuth.access = access;
    menuAuth.refresh = refresh;
    qlubLocalStorage.set('qlub.menu.auth', JSON.stringify(menuAuth));
};

export const getMenuAuth = (): IMenuAuth => {
    if (menuAuth.access && menuAuth.refresh) {
        return menuAuth;
    }
    const t = qlubLocalStorage.get('qlub.menu.auth');
    if (t) {
        try {
            const obj = JSON.parse(t);
            menuAuth.access = obj.access;
            menuAuth.refresh = obj.refresh;
        } catch (e) {
            console.log('setMenuAuth', e);
        }
    }
    return menuAuth;
};

export const deleteMenuAuth = () => {
    menuAuth.access = '';
    menuAuth.refresh = '';
    qlubLocalStorage.remove('qlub.menu.auth');
};
